var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconGlobe = function SvgIconGlobe(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10-4.477 10-10 10m-2.29-2.333A17.9 17.9 0 0 1 6.027 11H2.062a8.01 8.01 0 0 0 5.648 6.667M8.03 11c.151 2.439.848 4.73 1.97 6.752A15.9 15.9 0 0 0 11.97 11zm9.908 0h-3.965a17.9 17.9 0 0 1-1.683 6.667A8.01 8.01 0 0 0 17.938 11M2.062 9h3.965A17.9 17.9 0 0 1 7.71 2.333 8.01 8.01 0 0 0 2.062 9M8.03 9h3.938A15.9 15.9 0 0 0 10 2.248 15.9 15.9 0 0 0 8.03 9m4.259-6.667A17.9 17.9 0 0 1 13.973 9h3.965a8.01 8.01 0 0 0-5.648-6.667"
  })));
};
export default SvgIconGlobe;